import { Button, ButtonProps } from "@mui/material";
import { trackEvent } from "~/utils/monitoring";

interface LineageButtonProps {
  onOpenLineage: () => void;
  analyticsContext?: {
    dataset_id?: string;
    table_fqn?: string;
  };
  analyticsEvent?: string;
  size?: ButtonProps["size"];
  sx?: ButtonProps["sx"];
}

export function LineageButton({
  onOpenLineage,
  analyticsContext,
  analyticsEvent = "lineage_button_clicked",
  size,
  sx,
}: LineageButtonProps) {
  const handleClick = () => {
    if (analyticsContext) {
      trackEvent(analyticsEvent, analyticsContext);
    }
    onOpenLineage();
  };

  return (
    <Button
      variant="outlined"
      size={size}
      sx={sx}
      onClick={handleClick}
      data-testid="view-lineage-button"
    >
      View Lineage
    </Button>
  );
}
